export default __webpack_public_path__ + "static/media/HomeReme.0761bf63.svg";